<template>
    <div :style="styleOptions" @click="$emit('click')">
        <x-icon :class="iconClass" :color="circleIconColor" :size="circleIconSize"><slot /></x-icon>
    </div>
</template>

<script>
    export default {
        name: 'CircleIcon',
        props: ['size', 'iconSize', 'color', 'iconColor', 'iconClass', 'dark'],
        computed: {
            circleSize() {
                return this.size || 20;
            },
            circleIconSize() {
                return this.iconSize || this.circleSize * 0.8;
            },
            circleIconColor() {
                return this.iconColor || (this.dark ? 'black' : 'white')
            },
            styleOptions() {
                let styleObject = {
                    width: `${this.circleSize}px`,
                    minWidth: `${this.circleSize}px`,
                    height: `${this.circleSize}px`,
                    minHeight: `${this.circleSize}px`,
                    backgroundColor: this.color || (this.dark ? 'white' : 'black')
                };

                styleObject['background-color'] = this.color || (this.dark ? 'white' : 'black');

                return styleObject;
            }
        }
    }
</script>

<style lang="scss" scoped>

    div {
        position: relative;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        vertical-align: middle;
        border-radius: 100px;
        transition: background $transition-length;
    }
</style>
